// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3aj6g","addWidgetButton":"Header_addWidgetButton__1gBjR","dashboardTabs":"Header_dashboardTabs__1qxDD","active":"Header_active__zYhsH"};